import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/video.mp4'
import _imports_1 from '@/assets/tutorial/1.png'
import _imports_2 from '@/assets/tutorial/2.png'
import _imports_3 from '@/assets/tutorial/3.png'
import _imports_4 from '@/assets/tutorial/4.png'
import _imports_5 from '@/assets/tutorial/5.png'
import _imports_6 from '@/assets/tutorial/6.png'
import _imports_7 from '@/assets/tutorial/7.png'


const _hoisted_1 = { class: "app-menu" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", null, "🔥 The tutorial video is available ! 🔥 ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("video", {
  controls: "",
  width: "700"
}, [
  /*#__PURE__*/_createElementVNode("source", {
    src: _imports_0,
    type: "video/mp4"
  }),
  /*#__PURE__*/_createTextVNode(" Sorry, your browser doesn't support embedded videos. ")
], -1)
const _hoisted_5 = { class: "tutoral" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, "1. Data Browse. Biotech Category", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  class: "tutoral-content",
  src: _imports_1
}, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, "2. Data Browse. Biotechnology", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", {
  class: "tutoral-content",
  src: _imports_2
}, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", null, "3. Data Browse. Dataset", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("img", {
  class: "tutoral-content",
  src: _imports_3
}, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", null, "4. Data Browse. \"Gene expression\" mode for spatial data exploration", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("img", {
  class: "tutoral-content",
  src: _imports_4
}, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", null, "5. Data Browse. \"Color View\" mode for spatial data exploration", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("img", {
  class: "tutoral-content",
  src: _imports_5
}, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", null, "6. Data Browse. \"Attribute View\" mode for spatial data exploration", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("img", {
  class: "tutoral-content",
  src: _imports_6
}, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", null, "7. Data Search. Search data by specified information", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("img", {
  class: "tutoral-content",
  src: _imports_7
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _hoisted_2,
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_el_card, null, {
          default: _withCtx(() => [
            _hoisted_6,
            _createVNode(_component_el_divider),
            _hoisted_7
          ]),
          _: 1
        }),
        _createVNode(_component_el_card, null, {
          default: _withCtx(() => [
            _hoisted_8,
            _createVNode(_component_el_divider),
            _hoisted_9
          ]),
          _: 1
        }),
        _createVNode(_component_el_card, null, {
          default: _withCtx(() => [
            _hoisted_10,
            _createVNode(_component_el_divider),
            _hoisted_11
          ]),
          _: 1
        }),
        _createVNode(_component_el_card, null, {
          default: _withCtx(() => [
            _hoisted_12,
            _createVNode(_component_el_divider),
            _hoisted_13
          ]),
          _: 1
        }),
        _createVNode(_component_el_card, null, {
          default: _withCtx(() => [
            _hoisted_14,
            _createVNode(_component_el_divider),
            _hoisted_15
          ]),
          _: 1
        }),
        _createVNode(_component_el_card, null, {
          default: _withCtx(() => [
            _hoisted_16,
            _createVNode(_component_el_divider),
            _hoisted_17
          ]),
          _: 1
        }),
        _createVNode(_component_el_card, null, {
          default: _withCtx(() => [
            _hoisted_18,
            _createVNode(_component_el_divider),
            _hoisted_19
          ]),
          _: 1
        })
      ])
    ])
  ]))
}